/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, total: NonNullable<unknown> }} Chat_Blob_VersionInputs */



/**
* | output |
* | --- |
* | "Version {index} of {total}" |
*
* @param {Chat_Blob_VersionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blob_version = /** @type {((inputs: Chat_Blob_VersionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blob_VersionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Version ${i?.index} von ${i?.total}`)
	return /** @type {LocalizedString} */ (`Version ${i?.index} of ${i?.total}`)
});